// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrivacyPolicy_page__Kp3eA {
  background-color: #ffffff;
  padding: 80px 16px;
  padding-bottom: 0;
}

.PrivacyPolicy_container__f0eoQ {
  max-width: 1326px;
  margin: 0 auto;
  color: #1f2937;
  background-color: #fdfdfd;
  padding: 32px;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

.PrivacyPolicy_title__fl9fX {
  font-size: 32px;
  font-weight: 300;
  margin-bottom: 20px;
}
.PrivacyPolicy_hr__uPsWG {
  margin-top: 25px;
  margin-bottom: 30px;
  background-color: rgba(229, 231, 235, 1);
  height: 1px;
  border: none;
}

section {
  margin-bottom: 32px;
}

h2 {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  margin-bottom: 8px;

}

p {
  font-size: 14px;
  margin: 0;
  line-height: 1.7;
  color: #4b5563;
  margin-bottom: 8px;
}

ul {
  padding-left: 20px;
  margin: 8px 0 12px;
}

li {
  font-size: 14px;
  line-height: 1.7;
  color: #4b5563;
  margin-bottom: 0px;
}

a {
  color: #2563eb;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.PrivacyPolicy_note__sJ9tu {
  margin-top: 8px;
  font-size: 14px;
  color: #374151;
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/PrivacyPolicy.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,kBAAkB;;AAEpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB","sourcesContent":[".page {\n  background-color: #ffffff;\n  padding: 80px 16px;\n  padding-bottom: 0;\n}\n\n.container {\n  max-width: 1326px;\n  margin: 0 auto;\n  color: #1f2937;\n  background-color: #fdfdfd;\n  padding: 32px;\n  font-family: 'Inter', system-ui, -apple-system, sans-serif;\n}\n\n.title {\n  font-size: 32px;\n  font-weight: 300;\n  margin-bottom: 20px;\n}\n.hr {\n  margin-top: 25px;\n  margin-bottom: 30px;\n  background-color: rgba(229, 231, 235, 1);\n  height: 1px;\n  border: none;\n}\n\nsection {\n  margin-bottom: 32px;\n}\n\nh2 {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n  margin-bottom: 8px;\n\n}\n\np {\n  font-size: 14px;\n  margin: 0;\n  line-height: 1.7;\n  color: #4b5563;\n  margin-bottom: 8px;\n}\n\nul {\n  padding-left: 20px;\n  margin: 8px 0 12px;\n}\n\nli {\n  font-size: 14px;\n  line-height: 1.7;\n  color: #4b5563;\n  margin-bottom: 0px;\n}\n\na {\n  color: #2563eb;\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n.note {\n  margin-top: 8px;\n  font-size: 14px;\n  color: #374151;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `PrivacyPolicy_page__Kp3eA`,
	"container": `PrivacyPolicy_container__f0eoQ`,
	"title": `PrivacyPolicy_title__fl9fX`,
	"hr": `PrivacyPolicy_hr__uPsWG`,
	"note": `PrivacyPolicy_note__sJ9tu`
};
export default ___CSS_LOADER_EXPORT___;
